module.exports = __webpack_public_path__ + "img/confirmed_hk.8b1fa207.png";